import http from '../common/api';
import {ApiSettings} from "application";

const updateProfile = async (values) => {

  const {email, rut, phone, name, fatherLastName, motherLastName} = values;
  const request = {
    rut, phone: phone.replace(/\+/g, ''),
    name, email,
    fatherLastName,
    motherLastName,
    userUpdated: true
  };

  return await http.post(ApiSettings.saveProfile(values.unique_id), {profile: request}, {target: 'alf'});
}

export default updateProfile;
